var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4058 37.4758C29.9994 37.4758 37.7765 29.6986 37.7765 20.1051C37.7765 10.5115 29.9994 2.73438 20.4058 2.73438C10.8123 2.73438 3.03516 10.5115 3.03516 20.1051C3.03516 29.6986 10.8123 37.4758 20.4058 37.4758Z",
    fill: "white",
    stroke: "#9B2C51",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5898 22.7773C12.9261 27.5877 18.2709 30.5273 23.0812 29.1911C26.0209 28.1222 28.426 25.717 29.2278 22.7773",
    stroke: "#9B2C51",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4884 16.0979C27.1194 16.0979 26.8203 15.7988 26.8203 15.4298C26.8203 15.0608 27.1194 14.7617 27.4884 14.7617",
    stroke: "#9B2C51",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4862 16.0979C27.8552 16.0979 28.1543 15.7988 28.1543 15.4298C28.1543 15.0608 27.8552 14.7617 27.4862 14.7617",
    stroke: "#9B2C51",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3263 16.0979C12.9573 16.0979 12.6582 15.7988 12.6582 15.4298C12.6582 15.0608 12.9573 14.7617 13.3263 14.7617",
    stroke: "#9B2C51",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.328 16.0979C13.697 16.0979 13.9961 15.7988 13.9961 15.4298C13.9961 15.0608 13.697 14.7617 13.328 14.7617",
    stroke: "#9B2C51",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.5430deb38ed0a48744bbb3da26a304de.svg";
export { ForwardRef as ReactComponent };